import React from 'react';

interface Props {
  slots: string[];
  selectedTime: string | null;
  onSelect: (time: string) => void;
  accentColor?: string;
  disabledSlots?: string[];
}

export const SlotGrid: React.FC<Props> = ({
  slots,
  selectedTime,
  onSelect,
  accentColor = 'var(--bl-primary)',
  disabledSlots = [],
}) => (
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 8,
    padding: '4px 16px 16px',
  }}>
    {slots.map((time) => {
      const isDisabled = disabledSlots.includes(time);
      const isSelected = time === selectedTime && !isDisabled;
      return (
        <button
          key={time}
          type="button"
          disabled={isDisabled}
          onClick={() => !isDisabled && onSelect(time)}
          style={{
            height: 44,
            borderRadius: 'var(--bl-radius)',
            border: isDisabled
              ? '1px solid var(--bl-divider)'
              : isSelected
                ? `2px solid ${accentColor}`
                : '1px solid var(--bl-divider)',
            background: isDisabled
              ? 'var(--bl-surface)'
              : isSelected
                ? accentColor
                : 'var(--bl-surface)',
            color: isDisabled
              ? 'var(--bl-text-secondary)'
              : isSelected
                ? '#fff'
                : 'var(--bl-text)',
            fontSize: 13,
            fontWeight: isSelected ? 700 : 500,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            textDecoration: isDisabled ? 'line-through' : undefined,
            fontFamily: 'inherit',
            WebkitTapHighlightColor: 'transparent',
            transition: 'background 0.12s, border-color 0.12s',
          }}
        >
          {time}
        </button>
      );
    })}
  </div>
);
